import { styled } from '@mui/material';
import {
  DataGridPremium,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  useGridApiRef,
  // useKeepGroupedColumnsHidden,
} from '@mui/x-data-grid-premium';
import React from 'react';

const classes = {
  root: `MuiDataGrid-root`,
};
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '560px',
    width: '100%',
    '& .MuiDataGrid-root': {
      margin: '20px 25px',
      border: 'none',
      backgroundColor: '#fff',
    },
    '& .MuiTablePagination-toolbar': {
      alignItems: 'baseline',
    },
    '& .MuiDataGrid-main': {
      margin: '0 20px',
    },
    '& .MuiButton-root': {
      border: '1px solid #067F6F',
      margin: '10px',
      padding: '5px 20px',
      color: '#067F6F',
    },
    '& .css-2ulfj5-MuiTypography-root': {
      fontFamily: 'Work Sans',
      fontSize: '20px',
      fontWeight: 500,
    },
    '& .MuiDataGrid-virtualScroller': {
      width: '875px',
      height: '360px',
    },
    '& .MuiDataGrid-columnSeparator--resizable': {
      visibility: 'hidden',
    },
    '& .MuiDataGrid-toolbarContainer': {
      borderBottom: '1px solid lightgrey',
    },
    '& .css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
      backgroundColor: '#F1F2F3',
    },
  },
}));

function MuiTableComponent(props) {
  const {
    loading,
    styles = {},
    columnToolbar,
    filterToolbar,
    densityToolbar,
    exportToolbar,
    setFilterModel,
  } = props;

  const apiRef = useGridApiRef();

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {columnToolbar && <GridToolbarColumnsButton />}
        {filterToolbar && <GridToolbarFilterButton />}
        {densityToolbar && <GridToolbarDensitySelector />}
        {exportToolbar && <GridToolbarExport />}
      </GridToolbarContainer>
    );
  }

  return (
    // <div className={styles.root}>
    <Root className={classes.root}>
      <DataGridPremium
        {...props}
        apiRef={apiRef}
        loading={loading}
        disableSelectionOnClick
        components={{ Toolbar: CustomToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        onFilterModelChange={(data) => setFilterModel(data)}
      />
    </Root>
    // </div>
  );
}

export default MuiTableComponent;
